import type { StudioAnchor } from '@/components/korza-studio/studio-framing';
import { contrastRatio, meetsAA } from '@/lib/app-editor/color-contrast';
import type { CouponPosition } from '@/lib/app-editor/coupon-banner-form';

/** Zoomed in, the Studio keeps the banner in view: the phone's top or bottom. */
export function couponStudioAnchor(position: CouponPosition): StudioAnchor {
  return position;
}

export interface CouponContrast {
  ratio: number;
  readable: boolean;
  /** Share of the 21:1 scale, for the meter (0–1). */
  meter: number;
}

/** The banner text against its background, as the Studio and the Cor tab show it. */
export function couponContrast(
  backgroundColorHex: string,
  foregroundColorHex: string
): CouponContrast {
  const ratio = contrastRatio(backgroundColorHex, foregroundColorHex);
  return { ratio, readable: meetsAA(ratio), meter: Math.min(1, ratio / 21) };
}
